import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';

class Pagination extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            softTotal   : props.lastPage < 3 ? props.lastPage : 3,
            startPage   : 1,
            currentPage : props.currentPage,
            total       : props.total,
            lastPage    : props.lastPage,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.state.total, nextProps.total)) {
            this.setState({ total: nextProps.total });
            this.setState({ softTotal: nextProps.lastPage < 3 ? nextProps.lastPage : 3 });
            this.setState({ currentPage: nextProps.currentPage });
            this.setState({ lastPage: nextProps.lastPage });
        }
        if (!isEqual(this.state.currentPage, nextProps.currentPage)) {
            this.setState({ currentPage: nextProps.currentPage });
        }
    }

    changePage = (page) => {

        if (this.state.currentPage > 3) {
            this.setState({
                startPage : page - 1,
            });
        }

        this.setState({
            currentPage : page,
        });

        if (this.props.changePage) {
            this.props.changePage(page);
        }

        window.scrollTo(0, 500);
    }

    changeRange = (softTotal) => {
        this.setState({
            startPage : softTotal + 1,
        });
        this.changePage(softTotal+1);
    }

    render() {

        let currentPage = parseInt(this.state.currentPage);
        const total = this.state.total;

        if (total === 1) return null;

        let prev = null;
        let next = null;

        const pages = [];

        let softTotal = this.state.softTotal;
        let startPage;

        if (currentPage < 3) {
            startPage = 1;
        } else {
            startPage = currentPage -1;
            softTotal = startPage + 2;
        }

        if (currentPage > 1) {
            prev = (
                <li>
                    <button className="pagination-button prev" onClick={() => this.changePage(currentPage - 1)}><i className="icon icon-arrow-left"></i></button>
                </li>
            );
        }

        if (softTotal < this.state.lastPage) {
            next = (
                <li>
                    <button className="pagination-button next" onClick={() => this.changePage(currentPage + 1)}><i className="icon icon-arrow-left"></i></button>
                </li>
            );
        }

        for (let page = startPage; page <= softTotal; page++) {
            if (page <= this.state.lastPage) {
                pages.push(<li key={page}>
                    <button className={['pagination-button', (page === currentPage) && 'active'].join(' ')} onClick={() => this.changePage(page)}><span>{page}</span></button>
                </li>)
            }
        }

        if (this.state.currentPage < (this.state.lastPage -2)) {
            pages.push(<li key={0}>
                <button className="pagination-button etc" onClick={() => this.changeRange(softTotal, currentPage)}>...</button>
            </li>);
        }

        return ([
            <ul className="pagination">
                {prev}
                {pages}
                {next}
            </ul>
        ]);
    }
}

Pagination.propTypes = {
    changePage: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
};

export default Pagination;
